import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import {
  Snackbar,
  Alert,
  TextField,
  Box,
  InputAdornment,
  Icon,
  Typography,
} from "@mui/material";

function AmountField({ displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");

  const [number, setNumber] = useState(null);
  const [formattedNumber, setFormattedNumber] = useState(null);

  const handleInputChange = (e) => {
    const inputVal = e.target.value;
    const numberVal = inputVal.replace(/,/g, "");
    if (numberVal.length === 0) {
      setFormattedNumber("");
      return;
    }

    if (numberVal.endsWith(".")) {
      setFormattedNumber(numberVal);
      return;
    }

    const isnum = /^[0-9]\d*(\.\d+)?$/.test(numberVal);
    if (!isnum && !numberVal.endsWith(".")) {
      alert("No letters allowed.");
      setNumber(null);
      return;
    }

    const fNum = parseFloat(numberVal, 10).toLocaleString("en", {
      // minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    setFormattedNumber(fNum);
  };

  useEffect(() => {
    if (number === null) {
      return;
    }

    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [number]);

  return (
    <Box>
      <Box ml={0.5}>
        <Typography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </Typography>
      </Box>
      <TextField
        margin="dense"
        // label={displayName}
        type="text"
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>money</Icon>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          sx: {
            whiteSpace: "break-spaces",
          },
        }}
        value={formattedNumber}
        onChange={handleInputChange}
        onBlur={(e) => {
          // const entryValue = e.target.value;
          const inputVal = e.target.value;
          const entryValue = inputVal.replace(/,/g, "");

          // const isnum = /^\d+$/.test(entryValue);
          const isnum = /^[0-9]\d*(\.\d+)?$/.test(entryValue);
          if (!isnum) {
            e.target.value = null;
            setNumber(null);
            setErrMsg(`${displayName} requires only digits`);
            showFieldError(true);
            return;
          }

          const numValue = parseFloat(entryValue);
          if (typeof options.min_number !== "undefined") {
            if (numValue < options.min_number) {
              e.target.value = null;
              setNumber(null);
              setErrMsg(
                `${displayName} cannot be less than ${options.min_number}`
              );
              showFieldError(true);
              return;
            }
          }

          if (typeof options.max_number !== "undefined") {
            if (numValue > options.max_number) {
              e.target.value = null;
              setNumber(null);
              setErrMsg(
                `${displayName} cannot be more than ${options.max_number}`
              );
              showFieldError(true);
              return;
            }
          }

          setNumber(numValue);
        }}
        options={options}
      />
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={number}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
AmountField.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

AmountField.defaultProps = {
  options: null,
};

export default AmountField;
